exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "#replace-template-dropzone[data-v-29c05998]{min-height:126px}#replace-template-add-files[data-v-29c05998]{padding-top:36px}.dz-uploaded-file[data-v-29c05998]{cursor:default}.dz-uploaded-file .dz-upload-info[data-v-29c05998]{left:160px}.dz-uploaded-file .dz-progress[data-v-29c05998]{width:calc(100% - 172px)}.dz-uploaded-file .dz-filename.xlg[data-v-29c05998]{height:82px;max-height:82px}.dz-uploaded-file .dz-upload-info.xlg[data-v-29c05998]{left:12px}.dz-uploaded-file .dz-progress.xlg[data-v-29c05998]{width:calc(100% - 24px)}", ""]);

// exports
